import { SectionOne, SectionTwo } from "../components/feature/Invoice";

export default function InvoicePage()
{
    return(
        <section className="py-5 md:py-8 px-4 md:px-8 xl:px-10">
            <SectionOne/>
            <SectionTwo/>
        </section>
    );
}